<template>
    <div class="flex flex-col min-h-screen overflow-hidden">
  
      <!-- Site header -->
      <SiteHeader />
  
      <!-- Page content -->
      <main class="flex-grow">
  
        <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <div class="pt-32 pb-12 md:pt-2 md:pb-2">
          <div class="max-w-3xl mx-auto lg:max-w-none">

            <article>
            <!-- button back to blog --> 
            


            <!-- Article header -->
            <header class="max-w-3xl mx-auto mb-20">
                        
    <div class="blog">
    <router-link :to="'/tag/'+session" tag="a">&laquo; Back</router-link>
        <router-view />
        <div id="toc"></div>
        <router-link :to="'/tag/'+session" tag="a">&laquo; Back</router-link>
    </div>

</header>
</article>

    </div>
    </div>
    </div>
  
      </main>
  
      <!-- Site footer -->
      <Footer />
  
    </div>
  </template>
  
  <script>
  import SiteHeader from './../partials/Header.vue'
  import Footer from './../partials/Footer.vue'
  
  export default {
    name: 'BlogPost',
    data() {
      return {
        session: 'blog'
      }
    },
    components: {
      SiteHeader,
      Footer,
    },
    mounted() {
        this.session = this.$route.path.split('/')[1]
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .blog {
    max-width: 50vw;
    margin: 6rem auto;
  
    .back {
      background-color: #42b883;
      color: white;
      margin-top: 5rem;
      text-decoration: none;
      padding: 10px 15px;
      border: 1px solid currentColor;
      border-radius: .5rem;
      display: inline-block;
      transition: all .3s ease;
      &:hover {
        background-color: transparent;
        color: #42b883;
      }
    }
    
      h1 {
        font-size: 3rem;
        margin-bottom: .2rem;
        color: #42b883;
      }
      h4 {
        margin-bottom: 3rem;
        color: #35495e;
      }
      pre {
        overflow-x: auto;
        background-color: #35495e;
        color: black;
        border-radius: .3rem;
        padding: 1rem;
      }
      img {
        max-width: 100%;
      }
    }
  
  </style>